




























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { storePenunjang } from "@/store/modules/penunjang";
import CardListPenunjang from "@/components/kunjunganPasien/CardListPenunjang.vue";
import CardRiwayatPenunjangLain from "@/components/pemeriksaan/penunjang/CardRiwayatPenunjangLain.vue";

@Component({
  components: { CardListPenunjang, CardRiwayatPenunjangLain }
})
export default class CardModalRiwayatPenunjang extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() rm: number;
  @Prop() register: number;
  @Prop() type: string;
  @Prop() title: string;
  panel = [];
  searchKey = "";
  showdetail = false;

  get dialog() {
    if (this.value == true) {
      if (this.type == "ro") {
        storePenunjang.clear_hasil_ro();
        storePenunjang.clear_list_lab_ro();
        storePenunjang.get_list_ro_byRm(this.rm);
      } else if (this.type == "lab") {
        const param = {
          rm: this.rm,
          masuk: "",
          keluar: ""
        };
        storePenunjang.clear_list_lab_ro();
        storePenunjang.get_list_lab_byRm(param);
      } else {
        storePenunjang.act_penunjang_lain_byRm(this.rm);
        this.showdetail = true;
      }
    }
    return this.value;
  }
  set dialog(value) {
    this.$emit("input", value);
  }
  get listRo() {
    return storePenunjang.listRadiologi;
  }
  get listLab() {
    return storePenunjang.listLab.filter(listLab =>
      listLab["hasil"].some(result =>
        result.nama_test
          .toLowerCase()
          .includes(this.searchKey ? this.searchKey.toLowerCase() : "")
      )
    );
  }
  detailHasil(val) {
    if (val["tipe"] == "ro") {
      storePenunjang.clear_hasil_ro();
      storePenunjang.act_hasil_ro_byReg(val);
    }
  }
  tutup() {
    this.dialog = false;
    storePenunjang.clear_hasil_ro();
    this.showdetail = false;
  }
  mounted() {}
}
